import * as React from "react";
import Modal from "react-responsive-modal";
import Input from "../../../common/Input/Input";
import InputUtils, {Type} from "../../../../InputUtils";
import {useEffect, useState} from "react";
import './createTenantModalStyle.css';
import Utils from "../../../../Utils";
import {createTenant, getAllCountries} from "../../../../actions/boCoreActions";
import * as toastr from "toastr";
  
const CreateTenantModal = (props) => {

    const [form, setForm] = useState<any>({
        name: {
            value: '',
            valid: true,
            errorMsg: 'Tenant Name cannot be empty'
        },
        taxId: {
            value: '',
            valid: true,
            errorMsg: 'Company Tax ID cannot be empty'
        },
        webSite: {
            value: '',
            valid: true,
            errorMsg: 'Company Website cannot be empty'
        },
        country: {
            value: null,
            valid: true,
            errorMsg: 'Country cannot be empty'
        },
        timezone: {
            value: null,
            valid: true,
            errorMsg: 'Default Timezone cannot be empty'
        },
        subdomain: {
            value: "",
        },
        hasParentOrganization: {
            value: 0,
            valid: true
        },
        parentOrganization: {
            value: null,
            valid: true,
            errorMsg: 'Parent Organization cannot be empty'
        }
    });
    const [countryOptions, setCountryOptions] = useState<any[]>([]);

    useEffect(() => {
        getAllCountries()
            .then(response => {
                setCountryOptions(response.data
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(country => {
                        return {
                            value: country.id,
                            label: country.name
                        }
                    })
                );
            })
    }, []);

    const closeModal = () => {
        setForm(InputUtils.resetForm(form));
        props.onCloseModal();
    };

    const onChange = (event, id, inputType) => {
        let eventValue;
        if (inputType === 'select') {
            eventValue = event ? event : [];
        } else if (inputType === 'inputSwitch') {
            if (event.target.value === 'true') {
                eventValue = 0;
            } else {
                eventValue = 1;
            }
        } else {
            eventValue = event.target.value;
        }

        setForm({
            ...form,
            [id]: {
                ...form[id],
                value: eventValue,
                valid: true
            }
        });
    }

    const checkFormValidity = (): boolean => {
        const keys = Object.keys(form);
        const formCopy = JSON.parse(JSON.stringify(form));
        let formIsValid = true;
        keys.forEach((key: string, index: number) => {
            switch (key) {
                case 'name':
                case 'taxId':
                case 'webSite':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'timezone':
                case 'country':
                    if (!formCopy[key].value || Object.keys(formCopy[key].value).length < 1) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'parentOrganization':
                    if (formCopy['hasParentOrganization'].value === 1 &&
                        (!formCopy[key].value || Object.keys(formCopy[key].value).length < 1)) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
            }
        })

        setForm(formCopy);

        return formIsValid;
    }

    const handleCreateTenant = () => {
        if (checkFormValidity()) {
            const dto = {
                name: form.name.value,
                legalCompanyName: form.name.value,
                taxId: form.taxId.value,
                webSite: form.webSite.value,
                countryId: form.country.value?.value,
                timeZone: form.timezone.value?.value,
                subdomain: form.subdomain.value,
                hasParentOrganization: form.hasParentOrganization.value === 1
            };
            if (form.hasParentOrganization.value === 1) {
                dto['parentOrganizationId'] = form.parentOrganization.value?.value;
            }
            createTenant(dto)
                .then((response) => {
                    props.onCreate();
                    toastr.success('New tenant has been created successfully');
                })
                .finally(() => {
                    closeModal();
                })
        }
    };
 

    return (
        <Modal
            open={props.isOpen}
            styles={{
                overlay: {zIndex: 10000},
                closeButton: {display: "none"},
                modal: {
                    width: 750,
                    padding: 0,
                    maxWidth: 750,
                }
            }}
            closeOnEsc={true}
            onClose={closeModal}
            center
            focusTrapped={true}
            closeOnOverlayClick={false}
        >
            <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                <div className="row" style={{height: '100%'}}>
                    <div id={'create-tenant-container'} className='col-lg-12 compare-changes'>
                        <header className={'create-tenant-modal-header'}>
                            <h2>Create Tenant</h2>
                        </header>
                        <div className={'create-tenant-modal-container'}>
                            <div className={'create-tenant-form'}>
                                <Input id={'name'}
                                       value={form.name.value}
                                       required={true}
                                       elementType={Type.INPUT}
                                       changed={(event) => onChange(event, 'name', 'input')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       valid={form.name.valid}
                                       errorMsg={form.name.errorMsg}
                                       label={'Tenant Name'}
                                       elementConfig={{
                                           placeholder: 'Full Legal Company Registration Name',
                                           tabIndex: 1,
                                           autoComplete: 'off'
                                       }}
                                />
                                <Input id={'taxId'}
                                       value={form.taxId.value}
                                       required={true}
                                       elementType={Type.INPUT}
                                       changed={(event) => onChange(event, 'taxId', 'input')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       valid={form.taxId.valid}
                                       errorMsg={form.taxId.errorMsg}
                                       label={'Company Tax ID'}
                                       wrapperClass={'half-width-float-left'}
                                       elementConfig={{
                                           placeholder: 'Company Tax ID',
                                           tabIndex: 2,
                                           autoComplete: 'off'
                                       }}
                                />
                                <Input id={'webSite'}
                                       value={form.webSite.value}
                                       required={true}
                                       elementType={Type.INPUT}
                                       changed={(event) => onChange(event, 'webSite', 'input')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       valid={form.webSite.valid}
                                       errorMsg={form.webSite.errorMsg}
                                       label={'Company Website'}
                                       wrapperClass={'half-width'}
                                       elementConfig={{
                                           placeholder: 'Company Website',
                                           tabIndex: 3,
                                           autoComplete: 'off'
                                       }}
                                />
                                <Input id={'country'}
                                       value={form.country.value && Object.keys(form.country.value).length < 1 ? null : form.country.value}
                                       required={true}
                                       elementType={Type.SELECT}
                                       changed={(event) => onChange(event, 'country', 'select')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       errorMsg={form.country.errorMsg}
                                       valid={form.country.valid}
                                       selectInitialPosition={true}
                                       label={'Country'}
                                       wrapperClass={'half-width-float-left'}
                                       elementConfig={{
                                           placeholder: 'Select Country',
                                           isMulti: false,
                                           closeMenuOnSelect: true,
                                           tabIndex: 4,
                                           options: countryOptions,
                                           filterOption:Utils.filterOptions
                                       }}
                                />
                                <Input id={'timezone'}
                                       value={form.timezone.value && Object.keys(form.timezone.value).length < 1 ? null : form.timezone.value}
                                       required={true}
                                       elementType={Type.SELECT}
                                       changed={(event) => onChange(event, 'timezone', 'select')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       errorMsg={form.timezone.errorMsg}
                                       valid={form.timezone.valid}
                                       selectInitialPosition={true}
                                       label={'Default Timezone'}
                                       wrapperClass={'half-width'}
                                       elementConfig={{
                                           placeholder: 'Select Default Timezone',
                                           isMulti: false,
                                           closeMenuOnSelect: true,
                                           tabIndex: 5,
                                           options: Utils.moment_timezone.tz.names().map(tz => {
                                               return {
                                                   label: `${tz} (GMT${Utils.moment_timezone.tz(tz).format('Z')})`,
                                                   value: tz
                                               }
                                           })
                                       }}
                                />
                                    <Input
                                       id={"subdomain"}
                                       value={form.subdomain.value}
                                       elementType={Type.INPUT}
                                       changed={(event) =>
                                           onChange(event, "subdomain", "input")
                                          }
                                       classNameProp={
                                             "input-full-width margin-input-for-label"
                                           }
                                        label={"Tenant Subdomain Name"}
                                        wrapperClass={"half-width"}
                                        elementConfig={{
                                        placeholder:
                                        "Tenant Subdomain Name (Optional)",
                                        tabIndex: 1,
                                        autoComplete: "off",
                                    }}
                                />
                                <div style={{width: '100%', display: 'flex'}}>
                                    <div style={{marginRight: '1%'}}>
                                        <Input id={'hasParentOrganization'}
                                               value={form.hasParentOrganization.value === 1 ? "true" : "false"}
                                               required={true}
                                               elementType={Type.INPUT_SWITCH}
                                               changed={(event) => onChange(event, 'hasParentOrganization', 'inputSwitch')}
                                               classNameProp={'input-full-width margin-input-for-label'}
                                               labelExtraClass={'fullWidthLabel'}
                                               label={'Has Parent Organization'}
                                               elementConfig={{
                                                   tabIndex: 6
                                               }}
                                        />
                                    </div>
                                    {form.hasParentOrganization.value === 1 ?
                                        <div style={{width: '100%'}}>
                                            <Input id={'parentOrganization'}
                                                   value={form.parentOrganization.value && Object.keys(form.parentOrganization.value).length < 1 ? null : form.parentOrganization.value}
                                                   required={true}
                                                   elementType={Type.SELECT}
                                                   changed={(event) => onChange(event, 'parentOrganization', 'select')}
                                                   classNameProp={'input-full-width margin-input-for-label'}
                                                   errorMsg={form.parentOrganization.errorMsg}
                                                   valid={form.parentOrganization.valid}
                                                   selectInitialPosition={true}
                                                   label={'Parent Organization'}
                                                   elementConfig={{
                                                       placeholder: 'Select Parent Organization',
                                                       isMulti: false,
                                                       closeMenuOnSelect: true,
                                                       tabIndex: 7,
                                                       defaultValue: null,
                                                       cacheOptions: true,
                                                       options: props.tenantOptions
                                                   }}
                                            />
                                        </div> : null}
                                </div>
                            </div>
                        </div>
                        <footer style={{
                            background: "#2D3436",
                            borderTop: "2px solid #f5f5f5a3",
                            height: 49,
                            width: "100%",
                            paddingRight: 5,
                            paddingTop: 3,
                        }}>
                            <button
                                onClick={handleCreateTenant}
                                className={"btn"}
                                id={'btn-save'}
                                style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                <i className="fas fa-save"> Save</i>
                            </button>
                            <button
                                onClick={closeModal}
                                className={"btn"}
                                style={{float: "right", marginTop: 3, marginRight: 2}}>
                                <i className="fas fa-times"> Close</i>
                            </button>
                        </footer>
                    </div>
                </div>
            </div>
        </Modal>
    )
};

export default CreateTenantModal



// WEBPACK FOOTER //
// ./app/components/bo-core/modals/CreateTenantModal/CreateTenantModal.tsx